import { ToastNotification } from '@scenario/models/toast-notification.model';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface ToastNotificationState {
  toastNotifications: ToastNotification[];
}

const initialState: ToastNotificationState = {
  toastNotifications: [],
};

export const toastNotificationsSlice = createSlice({
  name: 'toastNotifications',
  initialState,
  reducers: {
    displayToast: (state, action: PayloadAction<ToastNotification>) => {
      state.toastNotifications.push(action.payload);
    },

    removeToastByReference: (state, action: PayloadAction<string>) => {
      state.toastNotifications = state.toastNotifications.filter(
        notification => notification.reference !== action.payload,
      );
    },
  },
});

export const { displayToast, removeToastByReference } = toastNotificationsSlice.actions;

export default toastNotificationsSlice.reducer;
